import type { VkPostEmbedParams } from '../types'
import { getVkPostElementId } from './getVkPostElementId'

export function parseVkPostCode(code: string): VkPostEmbedParams {
  const parsedCode = new DOMParser().parseFromString(code, 'text/html').body
    .innerHTML

  const [ownerId = '', postId = '', hash = ''] =
    parsedCode
      .match(/VK\.Widgets\.Post\([\S, ]+\)/gi)?.[0]
      .replace(/\)$/, '')
      .replace(/\s+/g, '')
      .split(',')
      .slice(1) || []

  const post = {
    owner_id: Number(ownerId) || 0,
    post_id: Number(postId) || 0,
    hash: hash.replace(/^['"]|['"]$/g, ''),
  }

  return {
    ...post,
    element_id: getVkPostElementId(post),
  }
}
